import OpenIcon from "./OpenIcon.mjs";

/** @type {GlyphIcon} */
export default OpenIcon;